export default (data) => {
  console.log("survey data", data);
  let new_data = [];
  //   data = data.features;
  //   for (let datum of data) {
  //     new_data.push(datum.properties);
  //   }
  return data;
};
